// Mitigates CVE-2024-4367 until PDF.js is upgraded to 4.2.67 or newer.
// Keep this object stable because React-PDF reloads documents when options change.
export const SECURE_PDF_OPTIONS = Object.freeze({
  isEvalSupported: false,
});

/** ~280mm at 96dpi — matches DocumentDetail's max preview width. */
export const PDF_PREVIEW_MAX_WIDTH_PX = 1058;

/**
 * Cap preview canvas width so large PDFs do not allocate multi‑megapixel
 * canvases per page (a common cause of blank pages after the first few).
 */
export const getPdfPreviewWidth = (
  maxWidth = PDF_PREVIEW_MAX_WIDTH_PX
): number => Math.min(Math.max(window.innerWidth - 10, 1), maxWidth);
